<template>
  <CustomDeleteDialog
    :dialogTitle="`حذف بج سواد ${
      defaultLiteracyBadge ? defaultLiteracyBadge.title : ''
    }`"
    dialogId="delete-literacy-badge-confirmation-dialog"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendLiteracyBadgeDeleteRequest"
  >
    <BCol cols="12">
      <p>
        آیا از حذف بج سواد
        <span class="font-weight-bolder">
          {{ defaultLiteracyBadge ? defaultLiteracyBadge.title : "" }}
        </span>
        اطمینان دارید؟
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    defaultLiteracyBadge: {
      type: Object,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendLiteracyBadgeDeleteRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let deleteALiteracyBadge = new DeleteALiteracyBadge(_this);
        deleteALiteracyBadge.setRequestParam({
          id: _this.defaultLiteracyBadge.id,
        });
        await deleteALiteracyBadge.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "بج سواد با موفقیت حذف شد.",
              },
            });
            this.$bvModal.hide("delete-literacy-badge-confirmation-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    BCol,
    CustomDeleteDialog,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { DeleteALiteracyBadge } from "@/libs/Api/LiteracyBadge";
import { BCol } from "bootstrap-vue";
</script>
